const transformOrigin = { x: 0.5, y: 0.5 };
export const getScaleMultiplier = (delta, speed = 1) => {
  const sign = Math.sign(delta);
  const deltaAdjustedSpeed = Math.min(0.25, Math.abs((speed * delta) / 128));
  return 1 - sign * deltaAdjustedSpeed;
};

export const getTransformOriginOffset = (owner) => {
  var ownerRect = owner.getBoundingClientRect();
  return {
    x: ownerRect.width * transformOrigin.x,
    y: ownerRect.height * transformOrigin.y,
  };
};

export const getOffsetXY = (e, owner) => {
  var offsetX, offsetY;
  // I tried using e.offsetX, but that gives wrong results for svg, when user clicks on a path.
  var ownerRect = owner.getBoundingClientRect();
  offsetX = e.clientX - ownerRect.left;
  offsetY = e.clientY - ownerRect.top;

  return { x: offsetX, y: offsetY };
};

export const getTranslateXY = (element) => {
  const style = window.getComputedStyle(element);
  const matrix = new DOMMatrixReadOnly(style.transform);
  return {
    x: matrix.m41,
    y: matrix.m42,
  };
};

export const getDistance = (a, b) => {
  var arect = a.getBoundingClientRect();
  var brect = b.getBoundingClientRect();

  // get a's center point
  var ax = arect.left + arect.width / 2;
  var ay = arect.top + arect.height / 2;

  // get b's center point
  var bx = brect.left + brect.width / 2;
  var by = brect.top + brect.height / 2;

  // calculate the distance using the Pythagorean Theorem (a^2 + b^2 = c^2)
  var distanceSquared = Math.pow(ax - bx, 2) + Math.pow(ay - by, 2);
  var distance = Math.sqrt(distanceSquared);
  return distance;
};
